export default function doubleExtensionChecker(filename: string, extensions: string[]) {
  const secondExt = filename.split('.')[filename.split('.').length - 2];

  return secondExt ? extensions.includes(secondExt.toLowerCase()) : false;
}
